import { useMutation } from '@tanstack/react-query';

import {
  type SendInfiniteEligibilityRegisterInterestEmailResponse,
  sendInfiniteEligibilityRegisterInterestEmail,
} from '~/services/LuxLoyalty';

interface UseSendInfiniteRegisterInterestEmailOptions {
  onSuccess?: (data: SendInfiniteEligibilityRegisterInterestEmailResponse) => void;
  onError?: (error: Error) => void;
}

/** Send the Infinite register-interest email for an eligible user and lock the sent flag on success. */
export function useSendInfiniteRegisterInterestEmail(options: UseSendInfiniteRegisterInterestEmailOptions = {}) {
  return useMutation({
    mutationFn: ({ id }: { id: string }) => sendInfiniteEligibilityRegisterInterestEmail(id),
    onSuccess: options.onSuccess,
    onError: options.onError,
  });
}
